import uid from "common/utils/uid";
import { polyLine2New } from "geom/polyLine2Types";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_48: DocMigration = {
  maxSchemaVersion: "0.0.48",
  description:
    "Resolve roof outlines in roof blocks, flatten roof blocks into separate table, assign persistent ids to roof systems and roofs",
  apply(json: any) {
    const { roofSystems, referenceGeom } = json;

    json.roofs = {};

    if (roofSystems) {
      const roofs = json.roofs;

      let roofSystemCount = 0;
      for (const roofSystemId of Object.keys(roofSystems)) {
        const roofSystem = roofSystems[roofSystemId];
        const newRoofSystemId = uid();
        roofSystem.id = newRoofSystemId;
        roofSystem.sortIndex = roofSystemCount++;

        delete roofSystems[roofSystemId];
        roofSystems[newRoofSystemId] = roofSystem;

        if (roofSystem.type !== "MULTI_GABLE") {
          continue;
        }

        const subRoofs = roofSystem.subRoofs;
        delete roofSystem.subRoofs;

        for (let i = 0; i < subRoofs.length; i++) {
          const roof = subRoofs[i];

          const roofId = uid();
          roof.id = roofId;
          roof.sortIndex = i;
          roof.roofSystemId = newRoofSystemId;

          const { blocks } = roof;

          if (blocks instanceof Array || typeof blocks === "string") {
            roofs[roofId] = roof;
            continue;
          }

          if (!json.levels[blocks.levelId]) {
            continue;
          }

          if (!(typeof blocks === "object" && blocks.type === "VIRTUAL_ROOF_BLOCK")) {
            console.assert(false);
          }

          if (typeof blocks === "object" && blocks.type === "VIRTUAL_ROOF_BLOCK") {
            const { geomId } = blocks.perimeter;
            const geom = referenceGeom[geomId];

            if (!geom) {
              continue;
            }

            roof.blocks = { ...blocks, perimeter: geom?.geom ?? polyLine2New([]) };
          }

          roofs[roofId] = roof;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_48;
